import '../components/promoBlock/scripts';
import '../components/emailSignup/scripts';
import '../components/connectedCollections/scripts';
import "../components/footer-localization/scripts/footer-localization.js";
import '../components/returnsAggregator/scripts';
